<template>
  <div class="main-app-container">
    <!-- <button @click="isTripPlanner = !isTripPlanner" class="add-trip-button">Trip planner toggle</button> -->
    <div
      class="main-categories"
      v-if="showParentCategories && config.features.lottieAnimations && !eventfeed"
      part="main-categories"
    >
      <template v-if="loadingCategories">
        <div v-for="n in 3" :key="n" class="main-category-skeleton">
          <div class="skeleton-lottie shimmer"></div>
          <div class="skeleton-label shimmer"></div>
        </div>
      </template>
      <template v-else>
        <button
          @click="((selectedParentCategory = seeAndDoCategory), (selectedCategory = ''))"
          part="main-category-button"
          class="main-category-button"
          :class="{
            active: selectedParentCategory == seeAndDoCategory || selectedParentCategory == 0,
          }"
        >
          <LottieAnimation
            :animation-data="seeAndDoAnimation"
            :scrollTrigger="true"
            :intersectionThreshold="0.3"
            width="118px"
          />
          <span class="main-category-text" v-html="getCategoryName(seeAndDoCategory)"></span>
        </button>
        <button
          @click="((selectedParentCategory = stayCategory), (selectedCategory = ''))"
          part="main-category-button"
          class="main-category-button"
          :class="{ active: selectedParentCategory == stayCategory || selectedParentCategory == 0 }"
        >
          <LottieAnimation
            :animation-data="stayAnimation"
            :scrollTrigger="true"
            :intersectionThreshold="0.3"
            width="118px"
          />
          <span class="main-category-text" v-html="getCategoryName(stayCategory)"></span>
        </button>
        <button
          @click="((selectedParentCategory = eatAndDrinkCategory), (selectedCategory = ''))"
          part="main-category-button"
          class="main-category-button"
          :class="{
            active: selectedParentCategory == eatAndDrinkCategory || selectedParentCategory == 0,
          }"
        >
          <LottieAnimation
            :animation-data="eatAndDrinkAnimation"
            :scrollTrigger="true"
            :intersectionThreshold="0.3"
            width="118px"
          />
          <span class="main-category-text" v-html="getCategoryName(eatAndDrinkCategory)"></span>
        </button>
      </template>
    </div>
    <div
      class="app-header"
      v-if="showParentCategories && !config.features.lottieAnimations && !eventfeed"
      :class="{ 'show-heading': headingText }"
    >
      <h2 v-if="headingText" class="app-heading" part="app-heading">{{ headingText }}</h2>
      <div class="main-categories" part="main-categories">
        <template v-if="loadingCategories">
          <div v-for="n in 3" :key="n" class="main-category-skeleton main-category-skeleton-simple">
            <div class="skeleton-label shimmer"></div>
          </div>
        </template>
        <template v-else>
          <button
            @click="((selectedParentCategory = seeAndDoCategory), (selectedCategory = ''))"
            part="main-category-button"
            class="main-category-button"
            :class="{
              active: selectedParentCategory == seeAndDoCategory || selectedParentCategory == 0,
            }"
          >
            <span class="main-category-text" v-html="getCategoryName(seeAndDoCategory)"></span>
          </button>
          <button
            @click="((selectedParentCategory = stayCategory), (selectedCategory = ''))"
            part="main-category-button"
            class="main-category-button"
            :class="{
              active: selectedParentCategory == stayCategory || selectedParentCategory == 0,
            }"
          >
            <span class="main-category-text" v-html="getCategoryName(stayCategory)"></span>
          </button>
          <button
            @click="((selectedParentCategory = eatAndDrinkCategory), (selectedCategory = ''))"
            part="main-category-button"
            class="main-category-button"
            :class="{
              active: selectedParentCategory == eatAndDrinkCategory || selectedParentCategory == 0,
            }"
          >
            <span class="main-category-text" v-html="getCategoryName(eatAndDrinkCategory)"></span>
          </button>
        </template>
      </div>
    </div>
    <div
      v-if="isMobile && (selectedParentCategory || showParentCategories === false) && !eventfeed"
      class="flex mobile-view-buttons"
    >
      <button
        class="mobile-view-button list-view"
        :class="{ active: !isMapView }"
        @click="setCurrentView('list')"
      >
        List view
      </button>
      <button
        class="mobile-view-button map-view"
        :class="{ active: isMapView }"
        @click="setCurrentView('map')"
      >
        Map view
      </button>
    </div>
    <div
      class="filter-and-app-container"
      v-if="selectedParentCategory || showParentCategories === false || eventfeed"
    >
      <div class="filter-menu" v-if="!isTripPlanner">
        <button @click="openFilterModal" class="flex filter-button">
          <svg
            v-if="config.features.lottieAnimations"
            id="Layer_2"
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            viewBox="0 0 26.03 25.4"
          >
            <g id="Layer_6">
              <rect y="1.85" width="26.03" height="2.8" />
              <rect y="20.75" width="26.03" height="2.8" />
              <rect y="11.3" width="26.03" height="2.8" />
              <circle cx="6.04" cy="3.25" r="3.25" />
              <circle cx="20.73" cy="12.7" r="3.25" />
              <circle cx="13.01" cy="22.15" r="3.25" />
            </g>
          </svg>
          <svg
            v-if="!config.features.lottieAnimations"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11.77 12.48"
          >
            <path
              d="M0 1.97h11.77M0 10.51h11.77M0 6.24h11.77"
              style="fill: none; stroke: #000; stroke-miterlimit: 10; stroke-width: 1.43px"
            />
            <circle
              cx="2.73"
              cy="1.97"
              r="1.47"
              style="fill: #fff; stroke: #000; stroke-miterlimit: 10"
            />
            <circle
              cx="9.37"
              cy="6.24"
              r="1.47"
              style="fill: #fff; stroke: #000; stroke-miterlimit: 10"
            />
            <circle
              cx="5.88"
              cy="10.51"
              r="1.47"
              style="fill: #fff; stroke: #000; stroke-miterlimit: 10"
            />
          </svg>
          <span v-if="!isMobile" class="filter-button-text">Filter</span>
        </button>
        <HorizontalScrollButtons
          :items="subcategories"
          :selected-item="selectedCategory"
          :loading="loadingCategories"
          @item-selected="onSelect"
        />
        <button
          part="toggle-map"
          class="toggle-map active"
          v-if="!isMobile && isListView && !eventfeed"
          @click="setCurrentView('hybrid')"
        >
          Show map
        </button>
        <button
          part="toggle-map"
          class="toggle-map active"
          v-if="!isMobile && isHybridView && !eventfeed"
          @click="setCurrentView('list')"
        >
          Hide map
        </button>
      </div>
      <div v-if="loadingOperators" class="skeleton-grid" part="skeleton-loader">
        <SkeletonCard v-for="n in 8" :key="n" />
      </div>
      <div
        v-if="!loadingOperators && filteredOperators.length === 0"
        class="no-results"
        part="no-results"
      >
        <h2>
          {{
            eventfeed
              ? "No events found for the selected filters."
              : "No operators found for the selected filters."
          }}
        </h2>
        <button @click="clearFilters" class="filter-options-clear btn">Clear Filters</button>
      </div>
      <div class="app-container" :class="{ 'trip-planner-active': isTripPlanner }" part="container">
        <!-- Operator List Section -->
        <div v-if="isTripPlanner && !isMapView" class="operator-list trip-planner-list" part="list">
          <!-- <button class="show-map-button">Show Map</button> -->
          <TripPlanner
            :operators="filteredOperators"
            @select-operator="selectOperator"
            @view-on-map="viewOnMap"
          />
        </div>
        <div
          v-if="(!isMobile && !isTripPlanner) || (!isTripPlanner && !isMapView)"
          class="operator-list"
          :class="{ 'operator-list-full': isListView, 'operator-list-hybrid': isHybridView }"
          part="list"
        >
          <!-- <button class="show-map-button">Show Map</button> -->
          <OperatorList
            :operators="filteredOperators"
            :randomize="!eventfeed"
            :primary-location="primaryLocationIds"
            @select-operator="selectOperator"
            @view-on-map="viewOnMap"
          />
        </div>

        <!-- Map Section -->
        <div
          v-if="isMapView || isHybridView || (isTripPlanner && !isMobile)"
          class="map-container"
          part="map"
        >
          <button
            @click="openFilterModal"
            v-if="!isTripPlanner && filterButtonInMap"
            class="filter-button rounded-full figtree flex"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.27 18.08" class="size-6">
              <path
                d="M16.61 4.35c-.28 1.25-1.16 2.05-2.06 2.9-.97.93-3.54 3.22-3.54 3.33.03.66.02 1.81-.03 2.48-.03.59-.12 1.2-.4 1.73-.26.48-.71.98-1.08 1.38-1.03 1.13-.73.87-1.96 1.39-.34.14-.67-.29-.67-.66 0-2 .04-3.18-.03-4.41-.04-.8-.04-1.37-.55-2.02-.45-.58-1.04-1.06-1.61-1.54-1.06-.88-2.01-1.87-2.98-2.85C.5 4.86.49 2.76.5 2.65c0-.12.02-.23 0-.34-.03-.38.27-.68.6-.8C3.56.11 11.1.55 12.51.62c1.12.04 2.49 0 3.47.64 1 .64.85 2.09.63 3.09Z"
                style="fill: none; stroke: #fff; stroke-miterlimit: 10"
              />
            </svg>
            Filter
          </button>
          <Suspense>
            <OperatorMap
              ref="mapComponent"
              :isTripPlanner="isTripPlanner"
              :operators="filteredOperators"
            />
          </Suspense>
        </div>

        <!-- Filter Modal -->
        <Transition
          enter-active-class="transition ease-out duration-200"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition ease-in duration-200"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <div v-if="isFilterModalOpen" class="filter-popup" @click.self="closeFilterModal">
            <div class="filter-popup-inner bg-white p-6 rounded-lg shadow-xl w-96 relative">
              <button @click="closeFilterModal" class="filter-close">
                <svg
                  class="filter-close-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <h2 class="filter-options mb-4 barlow">Filter Options</h2>
              <div class="space-y-4">
                <details
                  class="facilities"
                  v-if="config.features.locationFilter || eventfeed"
                >
                  <summary>
                    <h3>Location</h3>
                  </summary>
                  <div class="facilities-content">
                    <label v-for="location in nestedLocations" :key="location.id">
                      <input type="checkbox" :value="location.id" v-model="pendingLocation" />
                      <span v-html="location.name"></span>
                    </label>
                  </div>
                </details>
                <!-- Event-specific date filters -->
                <div class="flex filter-option" v-if="eventfeed">
                  <label class="figtree">Event Date From</label>
                  <input
                    ref="fromDatePicker"
                    type="text"
                    v-model="pendingEventFrom"
                    class="filter-option-input rounded-full"
                    placeholder="Select start date"
                  />
                </div>

                <div class="flex filter-option" v-if="eventfeed">
                  <label class="figtree">Event Date To</label>
                  <input
                    ref="toDatePicker"
                    type="text"
                    v-model="pendingEventTo"
                    class="filter-option-input rounded-full"
                    placeholder="Select end date"
                  />
                </div>

                <!-- Regular mode facility filters -->
                <div
                  class="flex filter-option"
                  v-if="
                    !eventfeed &&
                    selectedParentCategory === stayCategory &&
                    config.features.facilitiesFilter
                  "
                >
                  <!-- <label class="figtree">Facilities</label> -->
                  <!-- potentially replace with https://claude.ai/chat/798f31e1-1984-45df-8cfa-22aa97ed5589 -->
                  <!-- <select v-model="pendingFacilities" class="filter-option-select" multiple>
                                        <option v-for="facility in filteredFacilities" :key="facility.id" :value="facility.id"
                                            v-html="facility.name">
                                        </option>
                                    </select> -->
                </div>
                <details
                  class="facilities"
                  v-if="
                    !eventfeed &&
                    selectedParentCategory === stayCategory &&
                    config.features.facilitiesFilter
                  "
                >
                  <summary>
                    <h3>Facilities</h3>
                  </summary>
                  <div class="facilities-content">
                    <label v-for="facility in filteredFacilities" :key="facility.id">
                      <input type="checkbox" :value="facility.id" v-model="pendingFacilities" />
                      {{ facility.name }}
                    </label>
                  </div>
                </details>

                <div class="flex filter-option">
                  <label class="figtree flex items-center">
                    <input
                      type="checkbox"
                      v-model="pendingPetFriendly"
                      class="filter-option-checkbox mr-2"
                    />
                    Pet Friendly
                  </label>
                </div>

                <div class="flex filter-option">
                  <label class="figtree flex items-center">
                    <input
                      type="checkbox"
                      v-model="pendingAccessible"
                      class="filter-option-checkbox mr-2"
                    />
                    Accessible
                  </label>
                </div>

                <div class="flex filter-option">
                  <label class="figtree flex items-center">
                    <input
                      type="checkbox"
                      v-model="pendingEcoCertified"
                      class="filter-option-checkbox mr-2"
                    />
                    Eco Certified
                  </label>
                </div>

                <div class="flex filter-option">
                  <label class="figtree flex items-center">
                    <input
                      type="checkbox"
                      v-model="pendingBestOfQueensland"
                      class="filter-option-checkbox mr-2"
                    />
                    Best of Queensland
                  </label>
                </div>
              </div>

              <!-- Apply Filters Button -->
              <div class="popup-button-group">
                <button @click="applyFilters" class="filter-options-apply rounded-full">
                  Apply Filters
                </button>
                <button @click="clearFilters" class="filter-options-clear">Clear Filters</button>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  computed,
  onUnmounted,
  watchEffect,
  watch,
  defineAsyncComponent,
} from "vue";
import HorizontalScrollButtons from "./components/HorizontalScrollButtons.vue";
import {
  useOperatorsStore,
  useCategoriesStore,
  useLocationsStore,
  useFacilitiesStore,
  useViewStore,
  useConfigStore,
} from "./stores";
// import { useOperatorsStore } from './stores/operators.js'
import { storeToRefs } from "pinia";
import OperatorList from "./components/OperatorList.vue";
const loadMapboxCDN = () => {
  if (window.mapboxgl) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://api.mapbox.com/mapbox-gl-js/v3.20.0/mapbox-gl.js";
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

const OperatorMap = defineAsyncComponent(async () => {
  await loadMapboxCDN();
  return import("./components/OperatorMapbox.vue");
});
import OperatorTemplateTripPlannerButton from "./components/OperatorTemplateTripPlannerButton.vue";
import TripPlanner from "./components/TripPlanner.vue";
import { getDeviceInfo } from "./utils/device.js";
import { storageService } from "./services/storage.js";
import { debounce } from "./utils/performance.js";
import SkeletonCard from "./components/SkeletonCard.vue";
import LottieAnimation from "./components/LottieAnimation.vue";
import seeAndDoAnimation from "./assets/animations/see-and-do.json";
import eatAndDrinkAnimation from "./assets/animations/eat-and-drink.json";
import stayAnimation from "./assets/animations/stay.json";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";

// Stores
const operatorsStore = useOperatorsStore();
const { operators, loading: loadingOperators, error: errorOperators } = storeToRefs(operatorsStore);

const categoriesStore = useCategoriesStore();
const {
  categories,
  loading: loadingCategories,
  error: errorCategories,
} = storeToRefs(categoriesStore);

const locationsStore = useLocationsStore();
const {
  nestedLocations,
  loading: loadingLocations,
  error: errorLocations,
} = storeToRefs(locationsStore);

const facilitiesStore = useFacilitiesStore();
const {
  facilities,
  loading: loadingFacilities,
  error: errorFacilities,
} = storeToRefs(facilitiesStore);

const viewStore = useViewStore();
const { currentView, isListView, isHybridView, isMapView } = storeToRefs(viewStore);
const { setCurrentView } = viewStore;

const config = useConfigStore();

// Reactive state
const isTripPlanner = ref(false);
const filterButtonInMap = ref(false);
const storedOperatorIds = ref([]);
const isMobile = ref(true);
const mapComponent = ref(null);
const isFilterModalOpen = ref(false);
const selectedCategory = ref("");
const selectedLocation = ref([]);
const selectedFacilities = ref([]);
const pendingCategory = ref("");
const pendingLocation = ref([]);
const isFamilyFriendly = ref(false);
const isPetFriendly = ref(false);
const isAccessible = ref(false);
const isEcoCertified = ref(false);
const isBestOfQueensland = ref(false);
const pendingPetFriendly = ref(false);
const pendingAccessible = ref(false);
const pendingEcoCertified = ref(false);
const pendingBestOfQueensland = ref(false);
const pendingFacilities = ref([]);
const operatorTag = ref("");
const selectedParentCategory = ref(0);
const showParentCategories = ref(false);
const headingText = ref(config.categoriesPage.feedHeading || "");

// Event-specific reactive state
const eventFrom = ref("");
const eventTo = ref("");
const pendingEventFrom = ref("");
const pendingEventTo = ref("");
const fromDatePicker = ref(null);
const toDatePicker = ref(null);

const seeAndDoCategory = config.categories.seeAndDo;
const eatAndDrinkCategory = config.categories.eatAndDrink;
const stayCategory = config.categories.stay;

// Get parent category name from fetched categories
const getCategoryName = (id) => {
  const cat = categories.value.find((c) => c.id === id);
  return cat ? cat.name : "";
};

// Parse location prop into array of numeric IDs (supports single value or comma-separated list)
const propLocationIds = computed(() => {
  if (!props.location && props.location !== 0) return [];
  return String(props.location)
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => !Number.isNaN(id) && id > 0);
});

// Parse the page's ACF primary location into numeric term IDs (supports a single value or comma-separated list)
const primaryLocationIds = computed(() => {
  if (!props.primarylocation && props.primarylocation !== 0) return [];
  return String(props.primarylocation)
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => !Number.isNaN(id) && id > 0);
});

// Subcategories filtered from all categories by selected parent
const subcategories = computed(() => {
  if (!selectedParentCategory.value) return [];
  return categories.value.filter((c) => c.parent === selectedParentCategory.value);
});

// Props definition
const props = defineProps({
  category: {
    type: Number,
    default: "",
  },
  subcategory: {
    type: Number,
    default: "",
  },
  location: {
    type: [Number, String],
    default: "",
  },
  primarylocation: {
    type: [Number, String],
    default: "",
  },
  petfriendly: {
    type: Boolean,
    default: false,
  },
  accessible: {
    type: Boolean,
    default: false,
  },
  tripplanner: {
    type: Boolean,
    default: false,
  },
  operatortag: {
    type: Number,
    default: "",
  },
  showparentcategories: {
    type: Boolean,
    default: false,
  },
  eventfeed: {
    type: Boolean,
    default: false,
  },
  eventcategory: {
    type: Number,
    default: 182, // Default EVENT category ID
  },
  heading: {
    type: String,
    default: "",
  },
  custom_tags: {
    type: String,
    default: "",
  },
});

// Watch for localStorage changes
const updateStoredIds = () => {
  storedOperatorIds.value = storageService.getTripPlannerIds();
};

// Handle reorder events from TripPlannerOperatorCard
const handleTripPlannerReorder = (event) => {
  storedOperatorIds.value = event.detail.ids;
};

// Handle update events from TripPlannerButtonTransition
const handleTripPlannerUpdate = (event) => {
  storedOperatorIds.value = event.detail.ids;
};

// In trip planner mode, refetch when new IDs are added that aren't in the store
watch(storedOperatorIds, (newIds) => {
  if (!isTripPlanner.value || newIds.length === 0) return;
  const existingIds = new Set(operatorsStore.operators.map((op) => op.id));
  const hasNewIds = newIds.some((id) => !existingIds.has(id));
  if (hasNewIds) {
    operatorsStore.fetchOperators({ include: newIds.join(",") });
  }
});

const filteredFacilities = computed(() => {
  if (!filteredOperators.value || filteredOperators.value.length === 0) {
    return [];
  }

  // Get all facility IDs from the filtered operators
  const facilityIds = new Set();
  filteredOperators.value.forEach((operator) => {
    if (operator.facility && Array.isArray(operator.facility)) {
      operator.facility.forEach((facilityId) => facilityIds.add(facilityId));
    }
  });

  // Filter facilities to only include those used by filtered operators
  return facilities.value.filter((facility) => facilityIds.has(facility.id));
});

const filteredOperators = computed(() => {
  // Trip planner mode - return operators in stored order
  if (isTripPlanner.value === true) {
    const operatorMap = new Map(operators.value.map((operator) => [operator.id, operator]));
    return storedOperatorIds.value
      .map((id) => operatorMap.get(id))
      .filter((operator) => operator !== undefined);
  }

  // Start with base operators
  let result = operators.value;

  // Filter by event category if in event mode
  if (props.eventfeed) {
    result = result.filter((operator) => operator.website_category.includes(props.eventcategory));
  }

  // Apply additional filters if any are set
  const hasAdditionalFilters =
    selectedCategory.value ||
    selectedLocation.value.length > 0 ||
    selectedFacilities.value.length > 0 ||
    isPetFriendly.value ||
    isAccessible.value ||
    isEcoCertified.value ||
    isBestOfQueensland.value ||
    eventFrom.value ||
    eventTo.value;

  if (hasAdditionalFilters) {
    result = result.filter((operator) => {
      // Category filter
      if (selectedCategory.value && !operator.website_category.includes(selectedCategory.value)) {
        return false;
      }

      // Location filter — user-selected locations take priority; otherwise honor the prop's list of allowed locations
      if (selectedLocation.value.length > 0) {
        const inSelected = selectedLocation.value.some((id) => operator.location.includes(id));
        if (!inSelected) return false;
      } else if (propLocationIds.value.length > 0) {
        const inAllowedLocation = propLocationIds.value.some((id) => operator.location.includes(id));
        if (!inAllowedLocation) return false;
      }

      // Facilities filter (only for non-event mode and clients using the facilities filter)
      if (
        !props.eventfeed &&
        config.features.facilitiesFilter &&
        selectedFacilities.value.length > 0
      ) {
        const hasFacility = selectedFacilities.value.some((facilityId) =>
          operator.facility.includes(facilityId),
        );
        if (!hasFacility) return false;
      }

      // Pet friendly filter
      if (isPetFriendly.value && !operator.pet_friendly) {
        return false;
      }

      // Accessible filter
      if (isAccessible.value && !operator.accessible) {
        return false;
      }

      // Eco Certified filter (checks custom_tags taxonomy for eco-sustainability tag)
      if (isEcoCertified.value && (!operator.custom_tags || !operator.custom_tags.includes(322))) {
        return false;
      }

      // Best of Queensland filter (checks custom_tags taxonomy)
      if (isBestOfQueensland.value && (!operator.custom_tags || !operator.custom_tags.includes(329))) {
        return false;
      }

      return true;
    });
  }

  return result;
});

function getStoredIds() {
  const stored = localStorage.getItem("trip_planner_ids");
  try {
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error("Failed to parse localStorage data:", error);
    return [];
  }
}

const selectOperator = (operator) => {
  console.log("Selected operator:", operator);
};

const openFilterModal = () => {
  pendingCategory.value = selectedCategory.value;
  pendingLocation.value = [...selectedLocation.value];
  pendingPetFriendly.value = isPetFriendly.value;
  pendingAccessible.value = isAccessible.value;
  pendingEcoCertified.value = isEcoCertified.value;
  pendingBestOfQueensland.value = isBestOfQueensland.value;
  pendingFacilities.value = selectedFacilities.value;
  pendingEventFrom.value = eventFrom.value;
  pendingEventTo.value = eventTo.value;
  isFilterModalOpen.value = true;
};

const closeFilterModal = () => {
  isFilterModalOpen.value = false;
};

const applyFilters = () => {
  selectedCategory.value = pendingCategory.value;
  selectedLocation.value = pendingLocation.value;
  selectedFacilities.value = pendingFacilities.value;
  isPetFriendly.value = pendingPetFriendly.value;
  isAccessible.value = pendingAccessible.value;
  isEcoCertified.value = pendingEcoCertified.value;
  isBestOfQueensland.value = pendingBestOfQueensland.value;
  eventFrom.value = pendingEventFrom.value;
  eventTo.value = pendingEventTo.value;
  closeFilterModal();
};

const clearFilters = () => {
  selectedCategory.value = pendingCategory.value = "";
  selectedLocation.value = pendingLocation.value = [];
  selectedFacilities.value = pendingFacilities.value = [];
  isPetFriendly.value = pendingPetFriendly.value = false;
  isAccessible.value = pendingAccessible.value = false;
  isEcoCertified.value = pendingEcoCertified.value = false;
  isBestOfQueensland.value = pendingBestOfQueensland.value = false;
  eventFrom.value = pendingEventFrom.value = "";
  eventTo.value = pendingEventTo.value = "";
};

const viewOnMap = (operator) => {
  if (mapComponent.value) {
    mapComponent.value.focusMarker(operator);
  }
};

// Debounced device check for better performance
const updateDeviceCheck = debounce(() => {
  const deviceInfo = getDeviceInfo();
  isMobile.value = deviceInfo.isMobile;

  if (__DEV__) {
    console.log("Device updated:", deviceInfo);
  }
}, 100);

const getIdsFromUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    const idsParams = parsedUrl.searchParams.getAll("ids[]");
    if (!idsParams.length) {
      if (localStorage.getItem("trip_planner_ids")) {
        return JSON.parse(localStorage.getItem("trip_planner_ids") || "[]");
      }
    }
    return idsParams.map((id) => parseInt(id, 10)).filter((id) => !isNaN(id));
  } catch (error) {
    console.error("Error parsing URL:", error);
    return [];
  }
};

// Handle selection
const onSelect = (item) => {
  if (item.id === "all") {
    selectedCategory.value = "";
    return;
  }
  selectedCategory.value = item.id;
};

onMounted(async () => {
  console.log("Component mounted with props:", props);

  categoriesStore.fetchCategories();
  locationsStore.fetchLocations();

  // Only fetch facilities if not in event mode and the client uses the facilities filter
  if (!props.eventfeed && config.features.facilitiesFilter) {
    facilitiesStore.fetchFacilities();
  }

  // Set initial parent category based on mode
  // Note: the actual fetch is handled by watchEffect below
  if (props.eventfeed) {
    selectedParentCategory.value = props.eventcategory;
  } else if (props.category) {
    selectedParentCategory.value = props.category;
  }
  if (props.subcategory) {
    selectedCategory.value = props.subcategory;
  }
  if (propLocationIds.value.length > 0) {
    selectedLocation.value = [...propLocationIds.value];
  }
  if (props.petfriendly) {
    isFamilyFriendly.value = props.petfriendly;
  }
  if (props.custom_tags && String(props.custom_tags).split(",").includes("322")) {
    isEcoCertified.value = true;
  }
  if (props.custom_tags && String(props.custom_tags).split(",").includes("329")) {
    isBestOfQueensland.value = true;
  }
  if (props.tripplanner) {
    isTripPlanner.value = props.tripplanner === "true";
  }
  if (props.operatortag) {
    operatorTag.value = props.operatortag;
  }
  if (props.showparentcategories) {
    showParentCategories.value = props.showparentcategories === "true";
  }
  if (props.heading) {
    headingText.value = props.heading;
  }

  // Initialize stored IDs
  updateStoredIds();

  storedOperatorIds.value = getIdsFromUrl(window.location.href);

  // In trip planner mode, fetch operators by their stored IDs
  if (isTripPlanner.value && storedOperatorIds.value.length > 0) {
    operatorsStore.fetchOperators({ include: storedOperatorIds.value.join(",") });
  }

  // Add event listeners
  window.addEventListener("storage", updateStoredIds);
  window.addEventListener("tripPlannerReorder", handleTripPlannerReorder);
  window.addEventListener("tripPlannerUpdate", handleTripPlannerUpdate);
  window.addEventListener("resize", updateDeviceCheck);

  // Initial device check
  updateDeviceCheck();
});

// watchEffect for reactive data fetching
watchEffect(() => {
  if (selectedParentCategory.value && !props.eventfeed) {
    const params = { category: selectedParentCategory.value };
    if (props.operatortag) params.operatorTag = props.operatortag;
    if (propLocationIds.value.length > 0) params.location = propLocationIds.value.join(",");
    if (props.custom_tags) params.customTags = props.custom_tags;
    operatorsStore.fetchOperators(params);
  } else if (props.eventfeed) {
    // For event mode, refetch with date filters if they change
    const params = {
      category: props.eventcategory,
      orderby_event_date: true,
    };

    if (eventFrom.value) {
      params.event_from = eventFrom.value;
    }
    if (eventTo.value) {
      params.event_to = eventTo.value;
    }

    operatorsStore.fetchOperators(params);
  }
});

// Initialize flatpickr when modal opens (for event mode)
watchEffect(() => {
  if (isFilterModalOpen.value && props.eventfeed) {
    if (fromDatePicker.value && !fromDatePicker.value._flatpickr) {
      fromDatePicker.value._flatpickr = flatpickr(fromDatePicker.value, {
        dateFormat: "Y-m-d",
        onChange: (selectedDates, dateStr) => {
          pendingEventFrom.value = dateStr;
        },
      });
    }

    if (toDatePicker.value && !toDatePicker.value._flatpickr) {
      toDatePicker.value._flatpickr = flatpickr(toDatePicker.value, {
        dateFormat: "Y-m-d",
        onChange: (selectedDates, dateStr) => {
          pendingEventTo.value = dateStr;
        },
      });
    }
  }
});

// Cleanup on component unmount
onUnmounted(() => {
  window.removeEventListener("storage", updateStoredIds);
  window.removeEventListener("tripPlannerReorder", handleTripPlannerReorder);
  window.removeEventListener("tripPlannerUpdate", handleTripPlannerUpdate);
  window.removeEventListener("resize", updateDeviceCheck);
});
</script>

<style lang="scss">
:host {
  all: initial;
}

.main-app-container {
  container-type: inline-size;
  container-name: app;
  font-family: var(--vwc-font-body);
}

/* Use theme utility classes */
.barlow {
  font-family: var(--vwc-font-heading);
  font-style: normal;
}

.figtree {
  font-family: var(--vwc-font-body);
  font-optical-sizing: auto;
  font-style: normal;
}

.flex {
  display: flex;
}

.w-full {
  width: 100%;
}

.rounded-full {
  border-radius: var(--vwc-border-radius-full);
}

button {
  cursor: pointer;
}

.app-container {
  display: flex;
  gap: 40px;
  justify-content: center;
  height: 610px;
}

.app-container.trip-planner-active {
  height: calc(90vh - 80px);
}

.filter-and-app-container {
  // remove requested by VAW, might still need for VEG
  // border-top: 1px solid #E3E1DD;
  // padding-top: 45px;

  @media screen and (max-width: 768px) {
    padding-top: 16px;
  }
}

.show-map-button {
  position: fixed;
  top: 0;
}

.operator-list {
  flex-basis: 50%;
  overflow-y: auto;
  position: relative;
  padding: 0;
  max-width: 750px;
  flex-grow: 1;
  height: 610px;

  @media screen and (min-width: 1024px) {
    max-width: 1000px;
  }
}

.operator-list-full {
  max-width: 100%;
  @media screen and (min-width: 1024px) {
    max-width: 1500px;
  }
}

.trip-planner-list {
  max-width: 500px;
}

.map-container {
  width: 50%;
  position: relative;
  flex-grow: 1;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 610px;
  }
}

.filter-button {
  padding: var(--vwc-spacing-sm) var(--vwc-spacing-lg);
  border: var(--vwc-filter-button-border);
  background: var(--vwc-filter-button-background);
  color: var(--vwc-filter-button-color);
  margin-right: var(--vwc-spacing-sm);
  line-height: var(--vwc-filter-button-line-height, 1em);
  border-radius: var(--vwc-filter-button-border-radius);
  font-weight: var(--vwc-filter-button-font-weight, 700);

  &:hover {
    background: var(--vwc-filter-button-hover-background);
    color: var(--vwc-filter-button-hover-color);

    svg * {
      fill: var(--vwc-filter-button-color) !important;
      stroke: var(--vwc-filter-button-hover-color) !important;
    }
  }

  @media screen and (max-width: 768px) {
    padding: var(--vwc-spacing-md);
  }
}

.filter-button svg {
  width: 14px;
}

.filter-button-text {
  margin-left: var(--vwc-spacing-md);
}

.filter-options {
  font-size: 28px;
}

.filter-popup {
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.filter-popup-inner {
  background: var(--vwc-color-background);
  width: 100%;
  max-width: 400px;
  padding: var(--vwc-spacing-lg);
  border-radius: var(--vwc-border-radius-md);
  position: relative;
}

.filter-option {
  flex-direction: column;
  margin-bottom: var(--vwc-spacing-sm);
}

.filter-option-select {
  padding: var(--vwc-spacing-sm);
}

.filter-option-input {
  padding: var(--vwc-spacing-sm);
  border: 1px solid var(--vwc-color-primary);
  background: var(--vwc-color-background);
  color: var(--vwc-color-text);
  font-family: var(--vwc-font-body);

  &:focus {
    outline: none;
    border-color: var(--vwc-color-primary);
    box-shadow: 0 0 0 2px rgba(64, 29, 25, 0.1);
  }
}

.filter-options-apply {
  background: var(--vwc-button-background);
  color: var(--vwc-button-text);
  display: flex;
  border: 0;
  padding: var(--vwc-spacing-sm) var(--vwc-spacing-lg);
  align-items: center;
  font-weight: bold;
}

.filter-options-clear {
  background: transparent;
  border: 0;
  color: var(--vwc-color-primary);
  margin-left: var(--vwc-spacing-md);
  cursor: pointer;
  font-weight: bold;
}

.filter-close {
  background: transparent;
  border: 0;
  cursor: pointer;
  position: absolute;
  right: var(--vwc-spacing-sm);
  top: var(--vwc-spacing-sm);
  padding: 0;
}

.filter-close-icon {
  width: 20px;
  height: 20px;
}

.mobile-view-button {
  @extend .barlow;
  flex-basis: 50%;
  padding: 12px;
  border: 0;
  color: var(--vwc-color-primary);
  font-weight: 400;
  font-size: 13px;

  &.active {
    background: var(--vwc-active-background);
    color: var(--vwc-button-text);
  }
}

.list-view {
  border-radius: 6px 0 0 6px;
}

.map-view {
  border-radius: 0 6px 6px 0;
}

.filter-menu {
  display: flex;
  align-items: center;
  margin-bottom: 45px;
  // justify-content: center;
}

.main-categories {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 45px;
  margin-top: 80px;
  gap: 95px;

  @media screen and (max-width: 768px) {
    justify-content: space-around;
    gap: 0;
    flex-direction: column;
  }
}

.main-category-button {
  background: var(--vwc-main-category-button-background);
  border: var(--vwc-main-category-button-border);
  color: var(--vwc-main-category-button-color);
  opacity: 0.6;
  transition: opacity 0.3s ease;
  padding: 0;
  font-family: var(--vwc-main-category-button-font-family, var(--vwc-font-heading));
  font-weight: var(--vwc-main-category-button-font-weight, 400);

  padding: 9px 19px;
  border-radius: var(--vwc-main-category-button-border-radius);

  &.active {
    opacity: 1;
    background: var(--vwc-main-category-button-active-background);
    color: var(--vwc-main-category-button-active-color);
  }

  @media screen and (max-width: 768px) {
    > div {
      width: min(20vw, 100px) !important;
    }
  }
}

.main-category-skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.skeleton-lottie {
  width: 118px;
  height: 118px;
  border-radius: 50%;
  background-color: var(--vwc-color-secondary, #e0d6c8);

  @media screen and (max-width: 768px) {
    width: min(20vw, 100px);
    height: min(20vw, 100px);
  }
}

.skeleton-label {
  width: 80px;
  height: 1.2em;
  border-radius: 4px;
  background-color: var(--vwc-color-secondary, #e0d6c8);
}

.main-category-skeleton-simple {
  padding: 9px 19px;
}

.main-category-skeleton-simple .skeleton-label {
  width: 100px;
  height: 2em;
  border-radius: var(--vwc-main-category-button-border-radius);
}

.shimmer {
  background: linear-gradient(
    90deg,
    var(--vwc-color-secondary, #e0d6c8) 25%,
    color-mix(in srgb, var(--vwc-color-secondary, #e0d6c8), white 40%) 50%,
    var(--vwc-color-secondary, #e0d6c8) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite ease-in-out;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.main-category-icon {
  width: 120px;
  height: 120px;
  margin-right: var(--vwc-spacing-xs);
  display: block;
}

.main-category-text {
  font-size: 15px;
  color: inherit;
  //   color: var(--vwc-color-primary);
}

.subcategory-button {
  @extend .barlow;
  padding: var(--vwc-spacing-sm) var(--vwc-spacing-lg);
  border: 0;
  background: transparent;
  border: 2px solid var(--vwc-color-primary);
  color: var(--vwc-color-primary);
  margin-right: var(--vwc-spacing-sm);

  &.active {
    background: var(--vwc-color-primary);
    color: white;
  }
}

.filter-option-checkbox {
  width: 18px;
  height: 18px;
  accent-color: var(--vwc-color-primary);
  cursor: pointer;
}

.filter-option label {
  cursor: pointer;
  align-items: center;
  font-size: 15px;
}

.facilities label {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  font-family: var(--vwc-font-body);
}

.facilities input[type="checkbox"] {
  background-color: #fff;
  border-radius: 4px;
  width: 15px;
  height: 15px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-right: 5px;
  outline: none;
  border: solid 1px var(--vwc-color-primary);
}

details {
  margin: 0 0 2rem 0;
  padding: 10px 0;
  border-top: 1px solid var(--vwc-color-primary);
  border-bottom: 1px solid var(--vwc-color-primary);

  h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
  }
}

details summary {
  position: relative;
  padding: 5px 40px 5px 0;
  cursor: pointer;
  list-style: none;
  outline: none;
}

details summary::-webkit-details-marker {
  display: none;
}

details summary::after {
  content: "+";
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.3s ease;
  font-size: 40px;
}

details[open] summary::after {
  transform: translateY(-50%) rotate(180deg);
  content: "-";
}

details[open] summary {
  margin-bottom: 10px;
}

.pet-friendly {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.facilities {
  label {
    margin-bottom: 5px;
  }
}

.facilities-content {
  display: flex;
  flex-flow: column;
  overflow-y: scroll;
  padding-bottom: 1rem;
  max-height: 200px;
}

label {
  display: flex;
  align-items: center;
}

input[type="checkbox"] {
  background-color: white;
  border-radius: 4px;
  width: 15px;
  height: 15px;
  -webkit-appearance: none;
  appearance: none;
  margin-right: 5px;
  outline: none;
  border: solid 1px var(--vwc-color-primary);
}

input[type="checkbox"]:checked::after {
  background-color: var(--vwc-color-primary);
  content: "✓";
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.popup-button-group {
  display: flex;
  gap: 10px;
  margin-top: var(--vwc-spacing-lg);
}

.mr-2 {
  margin-right: 0.5rem;
}

.items-center {
  align-items: center;
}

@container app (min-width: 400px) {
  .header {
    padding: 1.5rem;
  }

  .nav {
    gap: 1.5rem;
  }

  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 46px;

  .main-categories {
    margin-top: 0;
    padding: 0;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    justify-content: center;

    .show-heading {
      justify-content: center;
    }
  }
}
.show-heading {
  justify-content: space-between;
}

.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
  padding: var(--vwc-spacing-sm);
}

@media screen and (min-width: 1024px) {
  .skeleton-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media screen and (min-width: 1280px) {
  .skeleton-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.no-results {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.5rem;
  text-align: center;
  flex-direction: column;
}

/* Add ::part selectors for web component customization */
my-app::part(container) {
  /* Custom styles for the container part */
}

my-app::part(map) {
  /* Custom styles for the map part */
}

my-app::part(list) {
  /* Custom styles for the list part */
}
</style>
